var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-dialog",
    {
      staticClass: "main-popup__wrap",
      attrs: { "md-active": _vm.showPopup, "md-backdrop": false },
      on: {
        "update:mdActive": function($event) {
          _vm.showPopup = $event
        },
        "update:md-active": function($event) {
          _vm.showPopup = $event
        },
        click: _vm.closePopup,
        "md-closed": _vm.closePopup
      }
    },
    [
      _c("div", { staticClass: "main-popup" }, [
        _vm.icon
          ? _c(
              "div",
              {
                staticClass: "main-popup__icon",
                class: "main-popup__icon-" + _vm.icon
              },
              [
                _c("div", {
                  staticClass: "icon__circle",
                  class: _vm.icon + "__icon"
                })
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.title
          ? _c("div", {
              staticClass: "main-popup__title",
              domProps: { innerHTML: _vm._s(_vm.title) }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.subTitle
          ? _c("div", {
              staticClass: "main-popup__sub-title",
              class: { "align-center": _vm.alignCenter },
              domProps: { innerHTML: _vm._s(_vm.subTitle) }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.text
          ? _c("div", {
              staticClass: "main-popup__text",
              class: { "align-center": _vm.alignCenter },
              domProps: { innerHTML: _vm._s(_vm.text) }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.confirmAction || _vm.cancelAction
          ? _c(
              "div",
              { staticClass: "btn-wrap space-between margin-top" },
              [
                _vm.confirmAction
                  ? _c(
                      "md-button",
                      {
                        staticClass: "btn md-primary",
                        attrs: { disabled: _vm.disabled },
                        on: {
                          click: function($event) {
                            return _vm.submitPopup()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.actionsText.confirm))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.cancelAction
                  ? _c(
                      "md-button",
                      {
                        staticClass: "btn md-primary",
                        on: {
                          click: function($event) {
                            _vm.closeByClick = true
                            _vm.closePopup()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.actionsText.cancel))]
                    )
                  : _vm._e()
              ],
              1
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-666e2322", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-666e2322","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/common/popups/PopupMain.vue
// module id = m7i5
// module chunks = 1